<div class="app-layout-overlapped-notifications">
  <core-notifications-main></core-notifications-main>
</div>